import { flockTheme } from '@flock/shared-ui'
import { ThemeProvider } from '@mui/material'
import React from 'react'
import { PostHogProvider } from 'posthog-js/react'
import ConfiguredApolloProvider from './apollo'
import TrackingWrapper from './TrackingWrapper'

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = ({ element }: any) => {
  const apiKey = process.env.GATSBY_PUBLIC_POSTHOG_KEY
  const options = {
    api_host: process.env.GATSBY_PUBLIC_POSTHOG_HOST,
  }

  if (!apiKey) {
    return (
      <ConfiguredApolloProvider>
        <TrackingWrapper>
          <ThemeProvider theme={flockTheme}>{element}</ThemeProvider>
        </TrackingWrapper>
      </ConfiguredApolloProvider>
    )
  }

  return (
    <ConfiguredApolloProvider>
      <PostHogProvider apiKey={apiKey} options={options}>
        <TrackingWrapper>
          <ThemeProvider theme={flockTheme}>{element}</ThemeProvider>
        </TrackingWrapper>
      </PostHogProvider>
    </ConfiguredApolloProvider>
  )
}
